import { ReduxProvider } from "components/common/ReduxProvider/ReduxProvider";
import { Translate } from "components/common/Translate/Translate";
import { FixedEditorLayout } from "components/modules/Layout/FixedEditorLayout/FixedEditorLayout";
import { EditorNavbar } from "components/modules/Navigation/EditorNavbar/EditorNavbar";
import { DesktopAction } from "./Action/DesktopAction";
import { BottomMenu } from "./BottomMenu/BottomMenu";
import { FlipSettings } from "./EditSettings/FlipSettings";
import { Preview } from "./Preview/Preview";

export const Flip = () => {
    return (
        <ReduxProvider>
            <FixedEditorLayout
                navbar={<EditorNavbar actionButton={null} url="/flip-image" />}
                action={{
                    desktop: null,
                }}
                bottomMenu={<BottomMenu />}
                controlBar={null}
                preview={<Preview />}
                leftBar={
                    <div className="flex flex-col justify-between h-full">
                        <div className="px-4">
                            <h1
                                className="text-2xl font-semibold whitespace-nowrap mt-2 pt-4 pb-4"
                                data-testid={`page-title`}
                            >
                                <Translate keyName="title" />
                            </h1>
                            <FlipSettings />
                        </div>
                        <div className="border-t border-t-irGray-200 dark:border-t-darkSurface-600">
                            <DesktopAction />
                        </div>
                    </div>
                }
                config={{
                    disableShadow: true,
                }}
            />
        </ReduxProvider>
    );
};
